import { GetAllCamposPersonalizadosDtoProps } from "./DTOs/GetAllCamposPersonalizadosDto"

export const getAllCamposPersonalizadosAdapter = (
  campo: GetAllCamposPersonalizadosDtoProps
): GetAllCamposPersonalizadosDtoProps => ({
  id: campo?.id,
  clave: campo?.clave,
})
